import PropTypes from 'prop-types'
import SearchResultPage from '@layouts/courses/search'

const SearchResults = ({ query }) => {
  return (
    <SearchResultPage query={query} />
  )
}

SearchResults.getInitialProps = async ({ query }) => ({ query })

SearchResults.propTypes = {
  query: PropTypes.object,
}

export default SearchResults
